<template>
  <div class="OUpload">
    <div class="img-uploader">
      <!-- image preview -->
      <div class="preview">
        <div
          class="img-item"
          :class="size"
          v-for="image in images"
          :key="image"
        >
          <!-- <previewImage :image="image" class="prev" /> -->
          <img :src="previewImage(image)" alt="Preview Image" v-if="image" />
          <span class="delete" @click="removeImage(image)">
            <i class="fas fa-trash"></i>
          </span>
          <span class="uploaded" v-if="image.uploadStatus == 'uploaded'"
            >Uploaded</span
          >
          <span class="failed" v-if="image.uploadStatus == 'failed'"
            >Failed</span
          >
        </div>
        <div
          class="dropzone"
          :class="[size, { compact: compact }]"
          v-if="images.length < 1"
        >
          <div>
            <div class="flex-col-center">
              <i class="fas fa-cloud-upload-alt"></i>
              <p>{{ text }}</p>
              <button class="outline">
                Add File<down v-if="multiple">s</down>
              </button>
            </div>
          </div>
          <div v-if="multiple && images.length > 0">+</div>
          <input
            type="file"
            @change="upload"
            :multiple="multiple"
            accept="image/*,.pdf,.doc,.docx,.xml,application/msword,.xlsx,.xlsm,"
            ref="file"
          />
        </div>
        <div class="dropzone2" :class="size" v-else>
          <span :class="size" v-if="multiple">+</span>
          <span class="change" :class="size" v-else>Change</span>
          <input
            type="file"
            @change="upload"
            :multiple="multiple"
            accept="image/*,.pdf,.doc,.docx,.xml,application/msword,.xlsx,.xlsm,"
            ref="file"
          />
        </div>
      </div>
      <!-- single image uploader dropzone -->
    </div>
    <!-- modern inline upload indicator (replaces the old full-page loader) -->
    <div v-if="uploading" class="ou-uploading">
      <span class="ou-spin"></span>
      <span class="ou-uploading-text">Uploading…</span>
    </div>
    <!-- upload btn -->
    <!-- <div class="upload-btn">
      <button @click="uploadImages()">Upload</button>
    </div> -->
  </div>
</template>
<script>
// import previewImage from "./previewImage.vue";
export default {
  name: "OUpload",
  components: {
    // previewImage,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "files/upload",
    },
    imagesBaseUrl: {
      type: String,
      default: "http://localhost:3000/",
    },
    value: {
      type: [String, Array],
      default: "",
    },
    text: {
      type: String,
      default: "Drag and drop file here, or click to browse",
    },
    size: {
      type: String,
      default: "md",
    },
    /** Smaller empty dropzone only; previews keep `size` (default md). */
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: [],
      imagesToUpload: [],
      previewUrl: "",
      uploading: false,
    };
  },
  methods: {
    previewImage(image) {
      const fileExtention = image.split(".").pop();
      if (
        fileExtention == "jpg" ||
        fileExtention == "jpeg" ||
        fileExtention == "png" ||
        fileExtention == "gif"
      ) {
        return this.$store.state.apiUploadUrl + image;
      } else if (fileExtention == "pdf") {
        return "/img/pdf.png";
      } else if (fileExtention == "doc" || fileExtention == "docx") {
        return "/img/word.png";
      } else if (
        fileExtention == "xls" ||
        fileExtention == "xlsx" ||
        fileExtention == "xlsm"
      ) {
        return "/img/excel.png";
      } else if (fileExtention == "ppt" || fileExtention == "pptx") {
        return "/img/ppt.png";
      } else if (fileExtention == "txt") {
        return "/img/file.png";
      } else {
        return "/img/file.png";
      }
    },
    upload() {
      if (this.$refs.file.files.length == 0) return;
      if (this.$refs.file.files.length == 1) {
        this.imagesToUpload.push(this.$refs.file.files[0]);
        this.uploadImages(this.$refs.file.files[0]);
      }
      if (this.$refs.file.files.length > 1) {
        for (let i = 0; i < this.$refs.file.files.length; i++) {
          this.imagesToUpload.push(this.$refs.file.files[i]);
          this.uploadImages(this.$refs.file.files[i]);
        }
      }
    },
    removeImage(image) {
      if (!confirm("Are you sure you want to delete this file?")) return;
      if (this.multiple) {
        this.images = this.images.filter((img) => img != image);
        this.$emit("imagesUploaded", this.images);
      } else {
        this.images = [];
        this.$emit("imagesUploaded", "");
      }
    },
    async uploadImages($image) {
      // Show the inline upload spinner instead of the old full-page loader. We still
      // emit start/stopLoader for any parent that listens, but the in-component
      // indicator is the primary feedback now.
      this.uploading = true;
      this.$emit("startLoader");
      await this.$store
        .dispatch("UPLOADIMAGES", {
          file: $image,
          url: this.uploadUrl,
        })
        .then((res) => {
          if (res.data.file_name) {
            if (this.multiple) {
              this.images.push(res.data.file_name);
            } else {
              this.images = [res.data.file_name];
            }
            if (this.multiple) {
              this.$emit("imagesUploaded", this.images);
            } else {
              this.$emit("imagesUploaded", this.images[0]);
            }
          } else {
            this.imagesToUpload.forEach((img) => {
              if (img.name == $image.name) {
                img.uploadStatus = "failed";
                this.$emit("imagesUploadedFailed", $image);
              }
            });
          }
        })
        .catch(() => {
          this.imagesToUpload.forEach((img) => {
            if (img.name == $image.name) {
              img.uploadStatus = "failed";
              this.$emit("imagesUploadedFailed", $image);
            }
          });
        })
        .finally(() => {
          this.uploading = false;
          this.$emit("stopLoader");
        });
    },
  },
  mounted() {
    if (this.value && this.value != "" && this.value != null) {
      if (this.multiple) {
        this.images = this.value;
      } else {
        this.images = [this.value];
      }
    }
  },
  watch: {
    value(val) {
      if (this.multiple) {
        this.images = val;
      } else {
        if ((val != "") & (val != null)) {
          this.images = [val];
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$primary_color: #1d2088;
$secondary_color: #1eb9ee;
.OUpload {
  .img-uploader {
    display: flex;
    flex-wrap: wrap;
  }
  .ou-uploading {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    padding: 6px 12px;
    background: #eef2ff;
    border: 1px solid #e0e7ff;
    border-radius: 999px;
    font-size: 0.8rem;
    color: $primary_color;
    .ou-uploading-text {
      font-weight: 600;
    }
    .ou-spin {
      width: 14px;
      height: 14px;
      border: 2px solid rgba(29, 32, 136, 0.25);
      border-top-color: $primary_color;
      border-radius: 50%;
      animation: ou-spin 0.6s linear infinite;
    }
  }
  .preview {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;

    width: 100%;
    .img-item {
      width: 100px;
      height: 100px;
      position: relative;
      &.sm {
        width: 50px;
        height: 50px;
      }
      &.md {
        width: 100px;
        height: 100px;
      }
      &.lg {
        width: 150px;
        height: 150px;
      }
      .delete {
        position: absolute;
        top: -5px;
        right: -5px;
        background: #c40505;
        color: #fff;
        padding: 5px;
        border-radius: 50%;
        font-size: 10px;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          background: #780202;
        }
      }
      .uploaded {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #4f934c;
        color: #fff;
        padding: 3px 5px;
        border-radius: 0 0 5px 5px;
        font-size: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .failed {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #c40505;
        color: #fff;
        padding: 3px 5px;
        border-radius: 0 0 5px 5px;
        font-size: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .prev {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .dropzone {
    width: 100%;
    height: 180px;
    border: 2px dashed #e2e2e2;
    background: #f5f5f5;
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    &:hover {
      // border: 10px dashed #000;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    span,
    .flex-col-center {
      font-size: 2rem;
      color: #ccc;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      &.change {
        font-size: 1rem;
      }
      &.sm {
        font-size: 1rem;
      }
    }
    &.compact {
      height: 88px;
      max-width: 240px;
      border-radius: 8px;
      border-width: 1px;
      .flex-col-center {
        row-gap: 3px;
        width: 100%;
        padding: 0 6px;
        i {
          font-size: 1.25rem;
          color: #94a3b8;
        }
        p {
          font-size: 0.7rem;
          line-height: 1.2;
          color: #64748b;
          margin: 0;
          padding: 0 4px;
        }
        .outline {
          font-size: 0.68rem;
          padding: 3px 8px;
          margin-top: 0;
        }
      }
    }
    &.lg {
      height: 220px;
    }
  }
  .dropzone2 {
    width: 100px;
    height: 100px;
    border: 1px dashed $primary_color;
    position: relative;
    &.sm {
      width: 50px;
      height: 50px;
    }
    &.md {
      width: 100px;
      height: 100px;
    }
    &.lg {
      width: 150px;
      height: 150px;
    }
    cursor: pointer;
    &:hover {
      border: 1px dashed #000;
      background: $secondary_color;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    span {
      font-size: 2rem;
      color: $primary_color;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      &.change {
        font-size: 1rem;
      }
      &.sm {
        font-size: 1rem;
      }
    }
  }
  .upload-btn {
    button {
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      background: #000;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
      &:hover {
        background: #333;
      }
    }
  }
}
.flex-col-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
  width: 100%;
  p {
    font-size: 1.05rem;
    color: #000;
    padding: 0 10px;
    text-align: center;
  }
  img {
    width: 40px;
    height: 40px;
  }
}
.outline {
  font-size: 1rem;
}
@keyframes ou-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>